export function Empty({ title = "No data yet", description, action, icon: Icon }) {
  return (
    <div className="surface p-12 text-center flex flex-col items-center gap-3">
      {Icon && <Icon className="w-10 h-10 text-muted-foreground/50" />}
      <div className="text-lg font-semibold">{title}</div>
      {description && <div className="text-sm text-muted-foreground max-w-md">{description}</div>}
      {action}
    </div>
  );
}
